// Settings saves (architecture sprint-04 §6.4, F49, F51). Not silent: the global toast shows server
// errors. No optimistic UI: on success the server's MeDto replaces ['me'].
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { ME_QUERY_KEY } from '@/hooks/use-me';
import { apiRequest } from '@/lib/api';
import { broadcast } from '@/lib/sync';
import type { Me, MeResponse, PreferencesPatch } from '@/types/me';

export function useUpdatePreferences(): UseMutationResult<MeResponse, Error, PreferencesPatch> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (patch) => apiRequest<MeResponse>('/api/me/preferences', { method: 'PATCH', body: JSON.stringify(patch) }),
    onSuccess: async (response, patch) => {
      queryClient.setQueryData<Me>(ME_QUERY_KEY, response.user);
      broadcast({ type: 'prefs-changed' });
      if (patch.timezone !== undefined) {
        // "Today", weeks and months all moved: refetch everything.
        broadcast({ type: 'entries-changed' });
        await queryClient.invalidateQueries();
      }
    },
  });
}
